import React, { FC } from "react";
import { Wrapper } from './styles';

export type Props = {
  title: string;
  children?: React.ReactNode;
};

const CardsList: FC<Props> = (props) => {
  return (
    <Wrapper>
      <h3>{props.title}</h3>
      {props.children}
    </Wrapper>
  );
};

export default CardsList;
